module.exports = __WEBPACK_EXTERNAL_MODULE_19__;


//////////////////
// WEBPACK FOOTER
// external "angular-resource"
// module id = 19
// module chunks = 0